import FormattedValue from './FormattedValue';
import { AreaUnit } from '@fulcrum/lib';
import { AreaFormatter } from '@trimble/utilities';
import { JSX } from 'solid-js';
import { BaseFormattedValueProps } from './base-formatted-value-props';
import { FormattingSettings } from '@trimble/types';

type Props = BaseFormattedValueProps<number, AreaUnit, FormattingSettings>;

export const FormattedArea = (props: Props): JSX.Element => {
  const toDisplay = (value: number): string =>
    AreaFormatter.toDisplay({
      measuredValue: value,
      currentUnits: props.currentUnit,
      settings: props.settings,
    });

  return (
    <FormattedValue
      toDisplay={toDisplay}
      {...(props as Omit<Props, 'settings' | 'currentUnit'>)}
    />
  );
};
